import * as X from "react";
import Zr, { forwardRef as vr, useContext as Xr, createContext as Vt, Children as Yt, cloneElement as Lt } from "react";
import { useMergeValue as Qr, isArray as Wt } from "@illa-design/system";
import { ReduceIcon as zt, SuccessIcon as Ut } from "@illa-design/icon";
import { getColor as De, globalColor as Fe, illaPrefix as je, applyBoxStyle as et, deleteCssProps as rt } from "@illa-design/theme";
import { css as Q } from "@emotion/react";
var sr = { exports: {} }, be = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Dr;
function Bt() {
  if (Dr)
    return be;
  Dr = 1;
  var e = Zr, r = Symbol.for("react.element"), n = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(f, p, v) {
    var d, g = {}, S = null, T = null;
    v !== void 0 && (S = "" + v), p.key !== void 0 && (S = "" + p.key), p.ref !== void 0 && (T = p.ref);
    for (d in p)
      a.call(p, d) && !i.hasOwnProperty(d) && (g[d] = p[d]);
    if (f && f.defaultProps)
      for (d in p = f.defaultProps, p)
        g[d] === void 0 && (g[d] = p[d]);
    return { $$typeof: r, type: f, key: S, ref: T, props: g, _owner: o.current };
  }
  return be.Fragment = n, be.jsx = l, be.jsxs = l, be;
}
var Ee = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Mr;
function qt() {
  return Mr || (Mr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Zr, r = Symbol.for("react.element"), n = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), f = Symbol.for("react.context"), p = Symbol.for("react.forward_ref"), v = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), g = Symbol.for("react.memo"), S = Symbol.for("react.lazy"), T = Symbol.for("react.offscreen"), w = Symbol.iterator, b = "@@iterator";
    function I(t) {
      if (t === null || typeof t != "object")
        return null;
      var s = w && t[w] || t[b];
      return typeof s == "function" ? s : null;
    }
    var m = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var s = arguments.length, u = new Array(s > 1 ? s - 1 : 0), E = 1; E < s; E++)
          u[E - 1] = arguments[E];
        _("error", t, u);
      }
    }
    function _(t, s, u) {
      {
        var E = m.ReactDebugCurrentFrame, P = E.getStackAddendum();
        P !== "" && (s += "%s", u = u.concat([P]));
        var D = u.map(function(R) {
          return String(R);
        });
        D.unshift("Warning: " + s), Function.prototype.apply.call(console[t], console, D);
      }
    }
    var x = !1, c = !1, M = !1, O = !1, Ke = !1, we;
    we = Symbol.for("react.module.reference");
    function He(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === a || t === i || Ke || t === o || t === v || t === d || O || t === T || x || c || M || typeof t == "object" && t !== null && (t.$$typeof === S || t.$$typeof === g || t.$$typeof === l || t.$$typeof === f || t.$$typeof === p || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === we || t.getModuleId !== void 0));
    }
    function Ze(t, s, u) {
      var E = t.displayName;
      if (E)
        return E;
      var P = s.displayName || s.name || "";
      return P !== "" ? u + "(" + P + ")" : u;
    }
    function Re(t) {
      return t.displayName || "Context";
    }
    function q(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case a:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case v:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case f:
            var s = t;
            return Re(s) + ".Consumer";
          case l:
            var u = t;
            return Re(u._context) + ".Provider";
          case p:
            return Ze(t, t.render, "ForwardRef");
          case g:
            var E = t.displayName || null;
            return E !== null ? E : q(t.type) || "Memo";
          case S: {
            var P = t, D = P._payload, R = P._init;
            try {
              return q(R(D));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var H = Object.assign, ee = 0, Te, Oe, le, Pe, de, $e, ke;
    function Ne() {
    }
    Ne.__reactDisabledLog = !0;
    function Xe() {
      {
        if (ee === 0) {
          Te = console.log, Oe = console.info, le = console.warn, Pe = console.error, de = console.group, $e = console.groupCollapsed, ke = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: Ne,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Qe() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: H({}, t, {
              value: Te
            }),
            info: H({}, t, {
              value: Oe
            }),
            warn: H({}, t, {
              value: le
            }),
            error: H({}, t, {
              value: Pe
            }),
            group: H({}, t, {
              value: de
            }),
            groupCollapsed: H({}, t, {
              value: $e
            }),
            groupEnd: H({}, t, {
              value: ke
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var pe = m.ReactCurrentDispatcher, ve;
    function ne(t, s, u) {
      {
        if (ve === void 0)
          try {
            throw Error();
          } catch (P) {
            var E = P.stack.trim().match(/\n( *(at )?)/);
            ve = E && E[1] || "";
          }
        return `
` + ve + t;
      }
    }
    var he = !1, ae;
    {
      var er = typeof WeakMap == "function" ? WeakMap : Map;
      ae = new er();
    }
    function h(t, s) {
      if (!t || he)
        return "";
      {
        var u = ae.get(t);
        if (u !== void 0)
          return u;
      }
      var E;
      he = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var D;
      D = pe.current, pe.current = null, Xe();
      try {
        if (s) {
          var R = function() {
            throw Error();
          };
          if (Object.defineProperty(R.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(R, []);
            } catch (Z) {
              E = Z;
            }
            Reflect.construct(t, [], R);
          } else {
            try {
              R.call();
            } catch (Z) {
              E = Z;
            }
            t.call(R.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Z) {
            E = Z;
          }
          t();
        }
      } catch (Z) {
        if (Z && E && typeof Z.stack == "string") {
          for (var C = Z.stack.split(`
`), W = E.stack.split(`
`), F = C.length - 1, j = W.length - 1; F >= 1 && j >= 0 && C[F] !== W[j]; )
            j--;
          for (; F >= 1 && j >= 0; F--, j--)
            if (C[F] !== W[j]) {
              if (F !== 1 || j !== 1)
                do
                  if (F--, j--, j < 0 || C[F] !== W[j]) {
                    var B = `
` + C[F].replace(" at new ", " at ");
                    return t.displayName && B.includes("<anonymous>") && (B = B.replace("<anonymous>", t.displayName)), typeof t == "function" && ae.set(t, B), B;
                  }
                while (F >= 1 && j >= 0);
              break;
            }
        }
      } finally {
        he = !1, pe.current = D, Qe(), Error.prepareStackTrace = P;
      }
      var se = t ? t.displayName || t.name : "", Ir = se ? ne(se) : "";
      return typeof t == "function" && ae.set(t, Ir), Ir;
    }
    function me(t, s, u) {
      return h(t, !1);
    }
    function oe(t) {
      var s = t.prototype;
      return !!(s && s.isReactComponent);
    }
    function re(t, s, u) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return h(t, oe(t));
      if (typeof t == "string")
        return ne(t);
      switch (t) {
        case v:
          return ne("Suspense");
        case d:
          return ne("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case p:
            return me(t.render);
          case g:
            return re(t.type, s, u);
          case S: {
            var E = t, P = E._payload, D = E._init;
            try {
              return re(D(P), s, u);
            } catch {
            }
          }
        }
      return "";
    }
    var Ae = Object.prototype.hasOwnProperty, xr = {}, Cr = m.ReactDebugCurrentFrame;
    function Ie(t) {
      if (t) {
        var s = t._owner, u = re(t.type, t._source, s ? s.type : null);
        Cr.setExtraStackFrame(u);
      } else
        Cr.setExtraStackFrame(null);
    }
    function Et(t, s, u, E, P) {
      {
        var D = Function.call.bind(Ae);
        for (var R in t)
          if (D(t, R)) {
            var C = void 0;
            try {
              if (typeof t[R] != "function") {
                var W = Error((E || "React class") + ": " + u + " type `" + R + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[R] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw W.name = "Invariant Violation", W;
              }
              C = t[R](s, R, E, u, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (F) {
              C = F;
            }
            C && !(C instanceof Error) && (Ie(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", E || "React class", u, R, typeof C), Ie(null)), C instanceof Error && !(C.message in xr) && (xr[C.message] = !0, Ie(P), y("Failed %s type: %s", u, C.message), Ie(null));
          }
      }
    }
    var gt = Array.isArray;
    function rr(t) {
      return gt(t);
    }
    function _t(t) {
      {
        var s = typeof Symbol == "function" && Symbol.toStringTag, u = s && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return u;
      }
    }
    function xt(t) {
      try {
        return Sr(t), !1;
      } catch {
        return !0;
      }
    }
    function Sr(t) {
      return "" + t;
    }
    function wr(t) {
      if (xt(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", _t(t)), Sr(t);
    }
    var ye = m.ReactCurrentOwner, Ct = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Rr, Tr, tr;
    tr = {};
    function St(t) {
      if (Ae.call(t, "ref")) {
        var s = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function wt(t) {
      if (Ae.call(t, "key")) {
        var s = Object.getOwnPropertyDescriptor(t, "key").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function Rt(t, s) {
      if (typeof t.ref == "string" && ye.current && s && ye.current.stateNode !== s) {
        var u = q(ye.current.type);
        tr[u] || (y('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', q(ye.current.type), t.ref), tr[u] = !0);
      }
    }
    function Tt(t, s) {
      {
        var u = function() {
          Rr || (Rr = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        u.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: u,
          configurable: !0
        });
      }
    }
    function Ot(t, s) {
      {
        var u = function() {
          Tr || (Tr = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        u.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: u,
          configurable: !0
        });
      }
    }
    var Pt = function(t, s, u, E, P, D, R) {
      var C = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: t,
        key: s,
        ref: u,
        props: R,
        // Record the component responsible for creating this element.
        _owner: D
      };
      return C._store = {}, Object.defineProperty(C._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(C, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.defineProperty(C, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(C.props), Object.freeze(C)), C;
    };
    function $t(t, s, u, E, P) {
      {
        var D, R = {}, C = null, W = null;
        u !== void 0 && (wr(u), C = "" + u), wt(s) && (wr(s.key), C = "" + s.key), St(s) && (W = s.ref, Rt(s, P));
        for (D in s)
          Ae.call(s, D) && !Ct.hasOwnProperty(D) && (R[D] = s[D]);
        if (t && t.defaultProps) {
          var F = t.defaultProps;
          for (D in F)
            R[D] === void 0 && (R[D] = F[D]);
        }
        if (C || W) {
          var j = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          C && Tt(R, j), W && Ot(R, j);
        }
        return Pt(t, C, W, P, E, ye.current, R);
      }
    }
    var nr = m.ReactCurrentOwner, Or = m.ReactDebugCurrentFrame;
    function ie(t) {
      if (t) {
        var s = t._owner, u = re(t.type, t._source, s ? s.type : null);
        Or.setExtraStackFrame(u);
      } else
        Or.setExtraStackFrame(null);
    }
    var ar;
    ar = !1;
    function or(t) {
      return typeof t == "object" && t !== null && t.$$typeof === r;
    }
    function Pr() {
      {
        if (nr.current) {
          var t = q(nr.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function kt(t) {
      {
        if (t !== void 0) {
          var s = t.fileName.replace(/^.*[\\\/]/, ""), u = t.lineNumber;
          return `

Check your code at ` + s + ":" + u + ".";
        }
        return "";
      }
    }
    var $r = {};
    function Nt(t) {
      {
        var s = Pr();
        if (!s) {
          var u = typeof t == "string" ? t : t.displayName || t.name;
          u && (s = `

Check the top-level render call using <` + u + ">.");
        }
        return s;
      }
    }
    function kr(t, s) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var u = Nt(s);
        if ($r[u])
          return;
        $r[u] = !0;
        var E = "";
        t && t._owner && t._owner !== nr.current && (E = " It was passed a child from " + q(t._owner.type) + "."), ie(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', u, E), ie(null);
      }
    }
    function Nr(t, s) {
      {
        if (typeof t != "object")
          return;
        if (rr(t))
          for (var u = 0; u < t.length; u++) {
            var E = t[u];
            or(E) && kr(E, s);
          }
        else if (or(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var P = I(t);
          if (typeof P == "function" && P !== t.entries)
            for (var D = P.call(t), R; !(R = D.next()).done; )
              or(R.value) && kr(R.value, s);
        }
      }
    }
    function At(t) {
      {
        var s = t.type;
        if (s == null || typeof s == "string")
          return;
        var u;
        if (typeof s == "function")
          u = s.propTypes;
        else if (typeof s == "object" && (s.$$typeof === p || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        s.$$typeof === g))
          u = s.propTypes;
        else
          return;
        if (u) {
          var E = q(s);
          Et(u, t.props, "prop", E, t);
        } else if (s.PropTypes !== void 0 && !ar) {
          ar = !0;
          var P = q(s);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof s.getDefaultProps == "function" && !s.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function It(t) {
      {
        for (var s = Object.keys(t.props), u = 0; u < s.length; u++) {
          var E = s[u];
          if (E !== "children" && E !== "key") {
            ie(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", E), ie(null);
            break;
          }
        }
        t.ref !== null && (ie(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), ie(null));
      }
    }
    function Ar(t, s, u, E, P, D) {
      {
        var R = He(t);
        if (!R) {
          var C = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (C += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var W = kt(P);
          W ? C += W : C += Pr();
          var F;
          t === null ? F = "null" : rr(t) ? F = "array" : t !== void 0 && t.$$typeof === r ? (F = "<" + (q(t.type) || "Unknown") + " />", C = " Did you accidentally export a JSX literal instead of a component?") : F = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", F, C);
        }
        var j = $t(t, s, u, P, D);
        if (j == null)
          return j;
        if (R) {
          var B = s.children;
          if (B !== void 0)
            if (E)
              if (rr(B)) {
                for (var se = 0; se < B.length; se++)
                  Nr(B[se], t);
                Object.freeze && Object.freeze(B);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Nr(B, t);
        }
        return t === a ? It(j) : At(j), j;
      }
    }
    function Dt(t, s, u) {
      return Ar(t, s, u, !0);
    }
    function Mt(t, s, u) {
      return Ar(t, s, u, !1);
    }
    var Ft = Mt, jt = Dt;
    Ee.Fragment = a, Ee.jsx = Ft, Ee.jsxs = jt;
  }()), Ee;
}
process.env.NODE_ENV === "production" ? sr.exports = Bt() : sr.exports = qt();
var We = sr.exports;
function Gt(e) {
  if (e.sheet)
    return e.sheet;
  for (var r = 0; r < document.styleSheets.length; r++)
    if (document.styleSheets[r].ownerNode === e)
      return document.styleSheets[r];
}
function Jt(e) {
  var r = document.createElement("style");
  return r.setAttribute("data-emotion", e.key), e.nonce !== void 0 && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode("")), r.setAttribute("data-s", ""), r;
}
var Kt = /* @__PURE__ */ function() {
  function e(n) {
    var a = this;
    this._insertTag = function(o) {
      var i;
      a.tags.length === 0 ? a.insertionPoint ? i = a.insertionPoint.nextSibling : a.prepend ? i = a.container.firstChild : i = a.before : i = a.tags[a.tags.length - 1].nextSibling, a.container.insertBefore(o, i), a.tags.push(o);
    }, this.isSpeedy = n.speedy === void 0 ? process.env.NODE_ENV === "production" : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var r = e.prototype;
  return r.hydrate = function(a) {
    a.forEach(this._insertTag);
  }, r.insert = function(a) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(Jt(this));
    var o = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var i = a.charCodeAt(0) === 64 && a.charCodeAt(1) === 105;
      i && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + a + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !i;
    }
    if (this.isSpeedy) {
      var l = Gt(o);
      try {
        l.insertRule(a, l.cssRules.length);
      } catch (f) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(a) && console.error('There was a problem inserting the following rule: "' + a + '"', f);
      }
    } else
      o.appendChild(document.createTextNode(a));
    this.ctr++;
  }, r.flush = function() {
    this.tags.forEach(function(a) {
      return a.parentNode && a.parentNode.removeChild(a);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), L = "-ms-", ze = "-moz-", $ = "-webkit-", hr = "comm", mr = "rule", yr = "decl", Ht = "@import", tt = "@keyframes", Zt = "@layer", Xt = Math.abs, Be = String.fromCharCode, Qt = Object.assign;
function en(e, r) {
  return Y(e, 0) ^ 45 ? (((r << 2 ^ Y(e, 0)) << 2 ^ Y(e, 1)) << 2 ^ Y(e, 2)) << 2 ^ Y(e, 3) : 0;
}
function nt(e) {
  return e.trim();
}
function rn(e, r) {
  return (e = r.exec(e)) ? e[0] : e;
}
function k(e, r, n) {
  return e.replace(r, n);
}
function cr(e, r) {
  return e.indexOf(r);
}
function Y(e, r) {
  return e.charCodeAt(r) | 0;
}
function _e(e, r, n) {
  return e.slice(r, n);
}
function J(e) {
  return e.length;
}
function br(e) {
  return e.length;
}
function Me(e, r) {
  return r.push(e), e;
}
function tn(e, r) {
  return e.map(r).join("");
}
var qe = 1, ue = 1, at = 0, z = 0, V = 0, fe = "";
function Ge(e, r, n, a, o, i, l) {
  return { value: e, root: r, parent: n, type: a, props: o, children: i, line: qe, column: ue, length: l, return: "" };
}
function ge(e, r) {
  return Qt(Ge("", null, null, "", null, null, 0), e, { length: -e.length }, r);
}
function nn() {
  return V;
}
function an() {
  return V = z > 0 ? Y(fe, --z) : 0, ue--, V === 10 && (ue = 1, qe--), V;
}
function U() {
  return V = z < at ? Y(fe, z++) : 0, ue++, V === 10 && (ue = 1, qe++), V;
}
function K() {
  return Y(fe, z);
}
function Ve() {
  return z;
}
function Se(e, r) {
  return _e(fe, e, r);
}
function xe(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function ot(e) {
  return qe = ue = 1, at = J(fe = e), z = 0, [];
}
function it(e) {
  return fe = "", e;
}
function Ye(e) {
  return nt(Se(z - 1, ur(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function on(e) {
  for (; (V = K()) && V < 33; )
    U();
  return xe(e) > 2 || xe(V) > 3 ? "" : " ";
}
function sn(e, r) {
  for (; --r && U() && !(V < 48 || V > 102 || V > 57 && V < 65 || V > 70 && V < 97); )
    ;
  return Se(e, Ve() + (r < 6 && K() == 32 && U() == 32));
}
function ur(e) {
  for (; U(); )
    switch (V) {
      case e:
        return z;
      case 34:
      case 39:
        e !== 34 && e !== 39 && ur(V);
        break;
      case 40:
        e === 41 && ur(e);
        break;
      case 92:
        U();
        break;
    }
  return z;
}
function cn(e, r) {
  for (; U() && e + V !== 47 + 10; )
    if (e + V === 42 + 42 && K() === 47)
      break;
  return "/*" + Se(r, z - 1) + "*" + Be(e === 47 ? e : U());
}
function un(e) {
  for (; !xe(K()); )
    U();
  return Se(e, z);
}
function fn(e) {
  return it(Le("", null, null, null, [""], e = ot(e), 0, [0], e));
}
function Le(e, r, n, a, o, i, l, f, p) {
  for (var v = 0, d = 0, g = l, S = 0, T = 0, w = 0, b = 1, I = 1, m = 1, y = 0, _ = "", x = o, c = i, M = a, O = _; I; )
    switch (w = y, y = U()) {
      case 40:
        if (w != 108 && Y(O, g - 1) == 58) {
          cr(O += k(Ye(y), "&", "&\f"), "&\f") != -1 && (m = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        O += Ye(y);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        O += on(w);
        break;
      case 92:
        O += sn(Ve() - 1, 7);
        continue;
      case 47:
        switch (K()) {
          case 42:
          case 47:
            Me(ln(cn(U(), Ve()), r, n), p);
            break;
          default:
            O += "/";
        }
        break;
      case 123 * b:
        f[v++] = J(O) * m;
      case 125 * b:
      case 59:
      case 0:
        switch (y) {
          case 0:
          case 125:
            I = 0;
          case 59 + d:
            m == -1 && (O = k(O, /\f/g, "")), T > 0 && J(O) - g && Me(T > 32 ? jr(O + ";", a, n, g - 1) : jr(k(O, " ", "") + ";", a, n, g - 2), p);
            break;
          case 59:
            O += ";";
          default:
            if (Me(M = Fr(O, r, n, v, d, o, f, _, x = [], c = [], g), i), y === 123)
              if (d === 0)
                Le(O, r, M, M, x, i, g, f, c);
              else
                switch (S === 99 && Y(O, 3) === 110 ? 100 : S) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Le(e, M, M, a && Me(Fr(e, M, M, 0, 0, o, f, _, o, x = [], g), c), o, c, g, f, a ? x : c);
                    break;
                  default:
                    Le(O, M, M, M, [""], c, 0, f, c);
                }
        }
        v = d = T = 0, b = m = 1, _ = O = "", g = l;
        break;
      case 58:
        g = 1 + J(O), T = w;
      default:
        if (b < 1) {
          if (y == 123)
            --b;
          else if (y == 125 && b++ == 0 && an() == 125)
            continue;
        }
        switch (O += Be(y), y * b) {
          case 38:
            m = d > 0 ? 1 : (O += "\f", -1);
            break;
          case 44:
            f[v++] = (J(O) - 1) * m, m = 1;
            break;
          case 64:
            K() === 45 && (O += Ye(U())), S = K(), d = g = J(_ = O += un(Ve())), y++;
            break;
          case 45:
            w === 45 && J(O) == 2 && (b = 0);
        }
    }
  return i;
}
function Fr(e, r, n, a, o, i, l, f, p, v, d) {
  for (var g = o - 1, S = o === 0 ? i : [""], T = br(S), w = 0, b = 0, I = 0; w < a; ++w)
    for (var m = 0, y = _e(e, g + 1, g = Xt(b = l[w])), _ = e; m < T; ++m)
      (_ = nt(b > 0 ? S[m] + " " + y : k(y, /&\f/g, S[m]))) && (p[I++] = _);
  return Ge(e, r, n, o === 0 ? mr : f, p, v, d);
}
function ln(e, r, n) {
  return Ge(e, r, n, hr, Be(nn()), _e(e, 2, -2), 0);
}
function jr(e, r, n, a) {
  return Ge(e, r, n, yr, _e(e, 0, a), _e(e, a + 1, -1), a);
}
function ce(e, r) {
  for (var n = "", a = br(e), o = 0; o < a; o++)
    n += r(e[o], o, e, r) || "";
  return n;
}
function dn(e, r, n, a) {
  switch (e.type) {
    case Zt:
      if (e.children.length)
        break;
    case Ht:
    case yr:
      return e.return = e.return || e.value;
    case hr:
      return "";
    case tt:
      return e.return = e.value + "{" + ce(e.children, a) + "}";
    case mr:
      e.value = e.props.join(",");
  }
  return J(n = ce(e.children, a)) ? e.return = e.value + "{" + n + "}" : "";
}
function pn(e) {
  var r = br(e);
  return function(n, a, o, i) {
    for (var l = "", f = 0; f < r; f++)
      l += e[f](n, a, o, i) || "";
    return l;
  };
}
function vn(e) {
  return function(r) {
    r.root || (r = r.return) && e(r);
  };
}
function hn(e) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return r[n] === void 0 && (r[n] = e(n)), r[n];
  };
}
var mn = function(r, n, a) {
  for (var o = 0, i = 0; o = i, i = K(), o === 38 && i === 12 && (n[a] = 1), !xe(i); )
    U();
  return Se(r, z);
}, yn = function(r, n) {
  var a = -1, o = 44;
  do
    switch (xe(o)) {
      case 0:
        o === 38 && K() === 12 && (n[a] = 1), r[a] += mn(z - 1, n, a);
        break;
      case 2:
        r[a] += Ye(o);
        break;
      case 4:
        if (o === 44) {
          r[++a] = K() === 58 ? "&\f" : "", n[a] = r[a].length;
          break;
        }
      default:
        r[a] += Be(o);
    }
  while (o = U());
  return r;
}, bn = function(r, n) {
  return it(yn(ot(r), n));
}, Vr = /* @__PURE__ */ new WeakMap(), En = function(r) {
  if (!(r.type !== "rule" || !r.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  r.length < 1)) {
    for (var n = r.value, a = r.parent, o = r.column === a.column && r.line === a.line; a.type !== "rule"; )
      if (a = a.parent, !a)
        return;
    if (!(r.props.length === 1 && n.charCodeAt(0) !== 58 && !Vr.get(a)) && !o) {
      Vr.set(r, !0);
      for (var i = [], l = bn(n, i), f = a.props, p = 0, v = 0; p < l.length; p++)
        for (var d = 0; d < f.length; d++, v++)
          r.props[v] = i[p] ? l[p].replace(/&\f/g, f[d]) : f[d] + " " + l[p];
    }
  }
}, gn = function(r) {
  if (r.type === "decl") {
    var n = r.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (r.return = "", r.value = "");
  }
}, _n = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", xn = function(r) {
  return r.type === "comm" && r.children.indexOf(_n) > -1;
}, Cn = function(r) {
  return function(n, a, o) {
    if (!(n.type !== "rule" || r.compat)) {
      var i = n.value.match(/(:first|:nth|:nth-last)-child/g);
      if (i) {
        for (var l = !!n.parent, f = l ? n.parent.children : (
          // global rule at the root level
          o
        ), p = f.length - 1; p >= 0; p--) {
          var v = f[p];
          if (v.line < n.line)
            break;
          if (v.column < n.column) {
            if (xn(v))
              return;
            break;
          }
        }
        i.forEach(function(d) {
          console.error('The pseudo class "' + d + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + d.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, st = function(r) {
  return r.type.charCodeAt(1) === 105 && r.type.charCodeAt(0) === 64;
}, Sn = function(r, n) {
  for (var a = r - 1; a >= 0; a--)
    if (!st(n[a]))
      return !0;
  return !1;
}, Yr = function(r) {
  r.type = "", r.value = "", r.return = "", r.children = "", r.props = "";
}, wn = function(r, n, a) {
  st(r) && (r.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), Yr(r)) : Sn(n, a) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), Yr(r)));
};
function ct(e, r) {
  switch (en(e, r)) {
    case 5103:
      return $ + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return $ + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return $ + e + ze + e + L + e + e;
    case 6828:
    case 4268:
      return $ + e + L + e + e;
    case 6165:
      return $ + e + L + "flex-" + e + e;
    case 5187:
      return $ + e + k(e, /(\w+).+(:[^]+)/, $ + "box-$1$2" + L + "flex-$1$2") + e;
    case 5443:
      return $ + e + L + "flex-item-" + k(e, /flex-|-self/, "") + e;
    case 4675:
      return $ + e + L + "flex-line-pack" + k(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return $ + e + L + k(e, "shrink", "negative") + e;
    case 5292:
      return $ + e + L + k(e, "basis", "preferred-size") + e;
    case 6060:
      return $ + "box-" + k(e, "-grow", "") + $ + e + L + k(e, "grow", "positive") + e;
    case 4554:
      return $ + k(e, /([^-])(transform)/g, "$1" + $ + "$2") + e;
    case 6187:
      return k(k(k(e, /(zoom-|grab)/, $ + "$1"), /(image-set)/, $ + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return k(e, /(image-set\([^]*)/, $ + "$1$`$1");
    case 4968:
      return k(k(e, /(.+:)(flex-)?(.*)/, $ + "box-pack:$3" + L + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $ + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return k(e, /(.+)-inline(.+)/, $ + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (J(e) - 1 - r > 6)
        switch (Y(e, r + 1)) {
          case 109:
            if (Y(e, r + 4) !== 45)
              break;
          case 102:
            return k(e, /(.+:)(.+)-([^]+)/, "$1" + $ + "$2-$3$1" + ze + (Y(e, r + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~cr(e, "stretch") ? ct(k(e, "stretch", "fill-available"), r) + e : e;
        }
      break;
    case 4949:
      if (Y(e, r + 1) !== 115)
        break;
    case 6444:
      switch (Y(e, J(e) - 3 - (~cr(e, "!important") && 10))) {
        case 107:
          return k(e, ":", ":" + $) + e;
        case 101:
          return k(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + $ + (Y(e, 14) === 45 ? "inline-" : "") + "box$3$1" + $ + "$2$3$1" + L + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (Y(e, r + 11)) {
        case 114:
          return $ + e + L + k(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return $ + e + L + k(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return $ + e + L + k(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return $ + e + L + e + e;
  }
  return e;
}
var Rn = function(r, n, a, o) {
  if (r.length > -1 && !r.return)
    switch (r.type) {
      case yr:
        r.return = ct(r.value, r.length);
        break;
      case tt:
        return ce([ge(r, {
          value: k(r.value, "@", "@" + $)
        })], o);
      case mr:
        if (r.length)
          return tn(r.props, function(i) {
            switch (rn(i, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return ce([ge(r, {
                  props: [k(i, /:(read-\w+)/, ":" + ze + "$1")]
                })], o);
              case "::placeholder":
                return ce([ge(r, {
                  props: [k(i, /:(plac\w+)/, ":" + $ + "input-$1")]
                }), ge(r, {
                  props: [k(i, /:(plac\w+)/, ":" + ze + "$1")]
                }), ge(r, {
                  props: [k(i, /:(plac\w+)/, L + "input-$1")]
                })], o);
            }
            return "";
          });
    }
}, Tn = [Rn], On = function(r) {
  var n = r.key;
  if (process.env.NODE_ENV !== "production" && !n)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (n === "css") {
    var a = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(a, function(b) {
      var I = b.getAttribute("data-emotion");
      I.indexOf(" ") !== -1 && (document.head.appendChild(b), b.setAttribute("data-s", ""));
    });
  }
  var o = r.stylisPlugins || Tn;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(n))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + n + '" was passed');
  var i = {}, l, f = [];
  l = r.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(b) {
      for (var I = b.getAttribute("data-emotion").split(" "), m = 1; m < I.length; m++)
        i[I[m]] = !0;
      f.push(b);
    }
  );
  var p, v = [En, gn];
  process.env.NODE_ENV !== "production" && v.push(Cn({
    get compat() {
      return w.compat;
    }
  }), wn);
  {
    var d, g = [dn, process.env.NODE_ENV !== "production" ? function(b) {
      b.root || (b.return ? d.insert(b.return) : b.value && b.type !== hr && d.insert(b.value + "{}"));
    } : vn(function(b) {
      d.insert(b);
    })], S = pn(v.concat(o, g)), T = function(I) {
      return ce(fn(I), S);
    };
    p = function(I, m, y, _) {
      d = y, process.env.NODE_ENV !== "production" && m.map !== void 0 && (d = {
        insert: function(c) {
          y.insert(c + m.map);
        }
      }), T(I ? I + "{" + m.styles + "}" : m.styles), _ && (w.inserted[m.name] = !0);
    };
  }
  var w = {
    key: n,
    sheet: new Kt({
      key: n,
      container: l,
      nonce: r.nonce,
      speedy: r.speedy,
      prepend: r.prepend,
      insertionPoint: r.insertionPoint
    }),
    nonce: r.nonce,
    inserted: i,
    registered: {},
    insert: p
  };
  return w.sheet.hydrate(f), w;
}, fr = { exports: {} }, N = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Lr;
function Pn() {
  if (Lr)
    return N;
  Lr = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, f = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, v = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, g = e ? Symbol.for("react.suspense") : 60113, S = e ? Symbol.for("react.suspense_list") : 60120, T = e ? Symbol.for("react.memo") : 60115, w = e ? Symbol.for("react.lazy") : 60116, b = e ? Symbol.for("react.block") : 60121, I = e ? Symbol.for("react.fundamental") : 60117, m = e ? Symbol.for("react.responder") : 60118, y = e ? Symbol.for("react.scope") : 60119;
  function _(c) {
    if (typeof c == "object" && c !== null) {
      var M = c.$$typeof;
      switch (M) {
        case r:
          switch (c = c.type, c) {
            case p:
            case v:
            case a:
            case i:
            case o:
            case g:
              return c;
            default:
              switch (c = c && c.$$typeof, c) {
                case f:
                case d:
                case w:
                case T:
                case l:
                  return c;
                default:
                  return M;
              }
          }
        case n:
          return M;
      }
    }
  }
  function x(c) {
    return _(c) === v;
  }
  return N.AsyncMode = p, N.ConcurrentMode = v, N.ContextConsumer = f, N.ContextProvider = l, N.Element = r, N.ForwardRef = d, N.Fragment = a, N.Lazy = w, N.Memo = T, N.Portal = n, N.Profiler = i, N.StrictMode = o, N.Suspense = g, N.isAsyncMode = function(c) {
    return x(c) || _(c) === p;
  }, N.isConcurrentMode = x, N.isContextConsumer = function(c) {
    return _(c) === f;
  }, N.isContextProvider = function(c) {
    return _(c) === l;
  }, N.isElement = function(c) {
    return typeof c == "object" && c !== null && c.$$typeof === r;
  }, N.isForwardRef = function(c) {
    return _(c) === d;
  }, N.isFragment = function(c) {
    return _(c) === a;
  }, N.isLazy = function(c) {
    return _(c) === w;
  }, N.isMemo = function(c) {
    return _(c) === T;
  }, N.isPortal = function(c) {
    return _(c) === n;
  }, N.isProfiler = function(c) {
    return _(c) === i;
  }, N.isStrictMode = function(c) {
    return _(c) === o;
  }, N.isSuspense = function(c) {
    return _(c) === g;
  }, N.isValidElementType = function(c) {
    return typeof c == "string" || typeof c == "function" || c === a || c === v || c === i || c === o || c === g || c === S || typeof c == "object" && c !== null && (c.$$typeof === w || c.$$typeof === T || c.$$typeof === l || c.$$typeof === f || c.$$typeof === d || c.$$typeof === I || c.$$typeof === m || c.$$typeof === y || c.$$typeof === b);
  }, N.typeOf = _, N;
}
var A = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Wr;
function $n() {
  return Wr || (Wr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, f = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, v = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, g = e ? Symbol.for("react.suspense") : 60113, S = e ? Symbol.for("react.suspense_list") : 60120, T = e ? Symbol.for("react.memo") : 60115, w = e ? Symbol.for("react.lazy") : 60116, b = e ? Symbol.for("react.block") : 60121, I = e ? Symbol.for("react.fundamental") : 60117, m = e ? Symbol.for("react.responder") : 60118, y = e ? Symbol.for("react.scope") : 60119;
    function _(h) {
      return typeof h == "string" || typeof h == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      h === a || h === v || h === i || h === o || h === g || h === S || typeof h == "object" && h !== null && (h.$$typeof === w || h.$$typeof === T || h.$$typeof === l || h.$$typeof === f || h.$$typeof === d || h.$$typeof === I || h.$$typeof === m || h.$$typeof === y || h.$$typeof === b);
    }
    function x(h) {
      if (typeof h == "object" && h !== null) {
        var me = h.$$typeof;
        switch (me) {
          case r:
            var oe = h.type;
            switch (oe) {
              case p:
              case v:
              case a:
              case i:
              case o:
              case g:
                return oe;
              default:
                var re = oe && oe.$$typeof;
                switch (re) {
                  case f:
                  case d:
                  case w:
                  case T:
                  case l:
                    return re;
                  default:
                    return me;
                }
            }
          case n:
            return me;
        }
      }
    }
    var c = p, M = v, O = f, Ke = l, we = r, He = d, Ze = a, Re = w, q = T, H = n, ee = i, Te = o, Oe = g, le = !1;
    function Pe(h) {
      return le || (le = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), de(h) || x(h) === p;
    }
    function de(h) {
      return x(h) === v;
    }
    function $e(h) {
      return x(h) === f;
    }
    function ke(h) {
      return x(h) === l;
    }
    function Ne(h) {
      return typeof h == "object" && h !== null && h.$$typeof === r;
    }
    function Xe(h) {
      return x(h) === d;
    }
    function Qe(h) {
      return x(h) === a;
    }
    function pe(h) {
      return x(h) === w;
    }
    function ve(h) {
      return x(h) === T;
    }
    function ne(h) {
      return x(h) === n;
    }
    function he(h) {
      return x(h) === i;
    }
    function ae(h) {
      return x(h) === o;
    }
    function er(h) {
      return x(h) === g;
    }
    A.AsyncMode = c, A.ConcurrentMode = M, A.ContextConsumer = O, A.ContextProvider = Ke, A.Element = we, A.ForwardRef = He, A.Fragment = Ze, A.Lazy = Re, A.Memo = q, A.Portal = H, A.Profiler = ee, A.StrictMode = Te, A.Suspense = Oe, A.isAsyncMode = Pe, A.isConcurrentMode = de, A.isContextConsumer = $e, A.isContextProvider = ke, A.isElement = Ne, A.isForwardRef = Xe, A.isFragment = Qe, A.isLazy = pe, A.isMemo = ve, A.isPortal = ne, A.isProfiler = he, A.isStrictMode = ae, A.isSuspense = er, A.isValidElementType = _, A.typeOf = x;
  }()), A;
}
process.env.NODE_ENV === "production" ? fr.exports = Pn() : fr.exports = $n();
var kn = fr.exports, ut = kn, Nn = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, An = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, ft = {};
ft[ut.ForwardRef] = Nn;
ft[ut.Memo] = An;
var In = !0;
function Dn(e, r, n) {
  var a = "";
  return n.split(" ").forEach(function(o) {
    e[o] !== void 0 ? r.push(e[o] + ";") : a += o + " ";
  }), a;
}
var lt = function(r, n, a) {
  var o = r.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (a === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  In === !1) && r.registered[o] === void 0 && (r.registered[o] = n.styles);
}, Mn = function(r, n, a) {
  lt(r, n, a);
  var o = r.key + "-" + n.name;
  if (r.inserted[n.name] === void 0) {
    var i = n;
    do
      r.insert(n === i ? "." + o : "", i, r.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function Fn(e) {
  for (var r = 0, n, a = 0, o = e.length; o >= 4; ++a, o -= 4)
    n = e.charCodeAt(a) & 255 | (e.charCodeAt(++a) & 255) << 8 | (e.charCodeAt(++a) & 255) << 16 | (e.charCodeAt(++a) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, r = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      r ^= (e.charCodeAt(a + 2) & 255) << 16;
    case 2:
      r ^= (e.charCodeAt(a + 1) & 255) << 8;
    case 1:
      r ^= e.charCodeAt(a) & 255, r = /* Math.imul(h, m): */
      (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  }
  return r ^= r >>> 13, r = /* Math.imul(h, m): */
  (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), ((r ^ r >>> 15) >>> 0).toString(36);
}
var jn = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, zr = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, Vn = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", Yn = /[A-Z]|^ms/g, dt = /_EMO_([^_]+?)_([^]*?)_EMO_/g, Er = function(r) {
  return r.charCodeAt(1) === 45;
}, Ur = function(r) {
  return r != null && typeof r != "boolean";
}, ir = /* @__PURE__ */ hn(function(e) {
  return Er(e) ? e : e.replace(Yn, "-$&").toLowerCase();
}), Ue = function(r, n) {
  switch (r) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(dt, function(a, o, i) {
          return G = {
            name: o,
            styles: i,
            next: G
          }, o;
        });
  }
  return jn[r] !== 1 && !Er(r) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
if (process.env.NODE_ENV !== "production") {
  var Ln = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, Wn = ["normal", "none", "initial", "inherit", "unset"], zn = Ue, Un = /^-ms-/, Bn = /-(.)/g, Br = {};
  Ue = function(r, n) {
    if (r === "content" && (typeof n != "string" || Wn.indexOf(n) === -1 && !Ln.test(n) && (n.charAt(0) !== n.charAt(n.length - 1) || n.charAt(0) !== '"' && n.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + n + "\"'`");
    var a = zn(r, n);
    return a !== "" && !Er(r) && r.indexOf("-") !== -1 && Br[r] === void 0 && (Br[r] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + r.replace(Un, "ms-").replace(Bn, function(o, i) {
      return i.toUpperCase();
    }) + "?")), a;
  };
}
var pt = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function Ce(e, r, n) {
  if (n == null)
    return "";
  if (n.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && n.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(pt);
    return n;
  }
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      if (n.anim === 1)
        return G = {
          name: n.name,
          styles: n.styles,
          next: G
        }, n.name;
      if (n.styles !== void 0) {
        var a = n.next;
        if (a !== void 0)
          for (; a !== void 0; )
            G = {
              name: a.name,
              styles: a.styles,
              next: G
            }, a = a.next;
        var o = n.styles + ";";
        return process.env.NODE_ENV !== "production" && n.map !== void 0 && (o += n.map), o;
      }
      return qn(e, r, n);
    }
    case "function": {
      if (e !== void 0) {
        var i = G, l = n(e);
        return G = i, Ce(e, r, l);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var f = [], p = n.replace(dt, function(d, g, S) {
          var T = "animation" + f.length;
          return f.push("const " + T + " = keyframes`" + S.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + T + "}";
        });
        f.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(f, ["`" + p + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + p + "`"));
      }
      break;
  }
  if (r == null)
    return n;
  var v = r[n];
  return v !== void 0 ? v : n;
}
function qn(e, r, n) {
  var a = "";
  if (Array.isArray(n))
    for (var o = 0; o < n.length; o++)
      a += Ce(e, r, n[o]) + ";";
  else
    for (var i in n) {
      var l = n[i];
      if (typeof l != "object")
        r != null && r[l] !== void 0 ? a += i + "{" + r[l] + "}" : Ur(l) && (a += ir(i) + ":" + Ue(i, l) + ";");
      else {
        if (i === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(pt);
        if (Array.isArray(l) && typeof l[0] == "string" && (r == null || r[l[0]] === void 0))
          for (var f = 0; f < l.length; f++)
            Ur(l[f]) && (a += ir(i) + ":" + Ue(i, l[f]) + ";");
        else {
          var p = Ce(e, r, l);
          switch (i) {
            case "animation":
            case "animationName": {
              a += ir(i) + ":" + p + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && i === "undefined" && console.error(Vn), a += i + "{" + p + "}";
          }
        }
      }
    }
  return a;
}
var qr = /label:\s*([^\s;\n{]+)\s*(;|$)/g, vt;
process.env.NODE_ENV !== "production" && (vt = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var G, Gr = function(r, n, a) {
  if (r.length === 1 && typeof r[0] == "object" && r[0] !== null && r[0].styles !== void 0)
    return r[0];
  var o = !0, i = "";
  G = void 0;
  var l = r[0];
  l == null || l.raw === void 0 ? (o = !1, i += Ce(a, n, l)) : (process.env.NODE_ENV !== "production" && l[0] === void 0 && console.error(zr), i += l[0]);
  for (var f = 1; f < r.length; f++)
    i += Ce(a, n, r[f]), o && (process.env.NODE_ENV !== "production" && l[f] === void 0 && console.error(zr), i += l[f]);
  var p;
  process.env.NODE_ENV !== "production" && (i = i.replace(vt, function(S) {
    return p = S, "";
  })), qr.lastIndex = 0;
  for (var v = "", d; (d = qr.exec(i)) !== null; )
    v += "-" + // $FlowFixMe we know it's not null
    d[1];
  var g = Fn(i) + v;
  return process.env.NODE_ENV !== "production" ? {
    name: g,
    styles: i,
    map: p,
    next: G,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: g,
    styles: i,
    next: G
  };
}, Gn = function(r) {
  return r();
}, Jn = X["useInsertionEffect"] ? X["useInsertionEffect"] : !1, Kn = Jn || Gn, Je = {}.hasOwnProperty, gr = /* @__PURE__ */ X.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ On({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (gr.displayName = "EmotionCacheContext");
gr.Provider;
var Hn = function(r) {
  return /* @__PURE__ */ vr(function(n, a) {
    var o = Xr(gr);
    return r(n, o, a);
  });
}, ht = /* @__PURE__ */ X.createContext({});
process.env.NODE_ENV !== "production" && (ht.displayName = "EmotionThemeContext");
var Jr = function(r) {
  var n = r.split(".");
  return n[n.length - 1];
}, Zn = function(r) {
  var n = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(r);
  if (n || (n = /^([A-Za-z0-9$.]+)@/.exec(r), n))
    return Jr(n[1]);
}, Xn = /* @__PURE__ */ new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]), Qn = function(r) {
  return r.replace(/\$/g, "-");
}, ea = function(r) {
  if (r)
    for (var n = r.split(`
`), a = 0; a < n.length; a++) {
      var o = Zn(n[a]);
      if (o) {
        if (Xn.has(o))
          break;
        if (/^[A-Z]/.test(o))
          return Qn(o);
      }
    }
}, lr = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", dr = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", mt = function(r, n) {
  if (process.env.NODE_ENV !== "production" && typeof n.css == "string" && // check if there is a css declaration
  n.css.indexOf(":") !== -1)
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + n.css + "`");
  var a = {};
  for (var o in n)
    Je.call(n, o) && (a[o] = n[o]);
  if (a[lr] = r, process.env.NODE_ENV !== "production" && n.css && (typeof n.css != "object" || typeof n.css.name != "string" || n.css.name.indexOf("-") === -1)) {
    var i = ea(new Error().stack);
    i && (a[dr] = i);
  }
  return a;
}, ra = function(r) {
  var n = r.cache, a = r.serialized, o = r.isStringTag;
  return lt(n, a, o), Kn(function() {
    return Mn(n, a, o);
  }), null;
}, yt = /* @__PURE__ */ Hn(function(e, r, n) {
  var a = e.css;
  typeof a == "string" && r.registered[a] !== void 0 && (a = r.registered[a]);
  var o = e[lr], i = [a], l = "";
  typeof e.className == "string" ? l = Dn(r.registered, i, e.className) : e.className != null && (l = e.className + " ");
  var f = Gr(i, void 0, X.useContext(ht));
  if (process.env.NODE_ENV !== "production" && f.name.indexOf("-") === -1) {
    var p = e[dr];
    p && (f = Gr([f, "label:" + p + ";"]));
  }
  l += r.key + "-" + f.name;
  var v = {};
  for (var d in e)
    Je.call(e, d) && d !== "css" && d !== lr && (process.env.NODE_ENV === "production" || d !== dr) && (v[d] = e[d]);
  return v.ref = n, v.className = l, /* @__PURE__ */ X.createElement(X.Fragment, null, /* @__PURE__ */ X.createElement(ra, {
    cache: r,
    serialized: f,
    isStringTag: typeof o == "string"
  }), /* @__PURE__ */ X.createElement(o, v));
});
process.env.NODE_ENV !== "production" && (yt.displayName = "EmotionCssPropInternal");
var bt = yt;
function te(e, r, n) {
  return Je.call(r, "css") ? We.jsx(bt, mt(e, r), n) : We.jsx(e, r, n);
}
function Kr(e, r, n) {
  return Je.call(r, "css") ? We.jsxs(bt, mt(e, r), n) : We.jsxs(e, r, n);
}
function ta(e, r = "blue") {
  let n = Q();
  return e && (n = Q`
      border-color: transparent;
      background-color: ${De(r, "01")};

      &:hover {
        background-color: ${De(r, "02")};
      }

      &:disabled {
        background-color: ${De(r, "06")};
      }
    `), Q`
    position: relative;
    appearance: none;
    border-radius: 2px;
    margin: auto;
    width: 16px;
    height: 16px;
    border: solid 2px ${Fe(`--${je}-grayBlue-08`)};
    cursor: pointer;
    transition: 0.15s all linear;

    &:hover {
      border-color: ${De(r, "06")};
    }

    &:disabled {
      cursor: not-allowed;
      border-color: ${Fe(`--${je}-grayBlue-08`)};
      background-color: ${Fe(`--${je}-grayBlue-09`)};
    }

    ${n}
  `;
}
function Hr(e) {
  return Q`
    position: absolute;
    left: 0;
    width: 16px;
    height: 8px;
    transform: ${e ? "scale(1);" : "scale(0);"};
    color: white;
    transition: 0.15s all linear;
    pointer-events: none;
  `;
}
function na(e) {
  const r = e.disabled ?? !1;
  return Q`
    position: relative;
    display: inline-flex;
    overflow: hidden;
    word-wrap: break-word;
    white-space: nowrap;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    line-height: 22px;
    color: ${Fe(`--${je}-grayBlue-02`)};
    cursor: ${r ? "not-allowed" : "pointer"};
  `;
}
function aa(e) {
  const r = typeof e == "string" ? e : `${e}px`;
  return Q`
    display: inline-flex;
    vertical-align: middle;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px ${r};
    margin-right: ${r};
  `;
}
function oa(e) {
  const r = typeof e == "string" ? e : `${e}px`;
  return Q`
    display: inline-flex;
    vertical-align: middle;
    flex-direction: column;
    align-items: flex-start;
    gap: ${r};
    margin-bottom: ${r};
  `;
}
const ia = Q`
  margin-left: 8px;
`, _r = Vt({});
_r.displayName = "CheckboxGroupContext";
const pr = vr((e, r) => {
  var I, m;
  const { value: n, disabled: a, checked: o, defaultChecked: i, indeterminate: l, onChange: f, colorScheme: p = "blue", children: v, ...d } = e, g = Xr(_r), S = o ?? ((I = g.value) == null ? void 0 : I.some((y) => y === n)), T = i ?? ((m = g.defaultValue) == null ? void 0 : m.some((y) => y === n)), [w, b] = Qr(!1, {
    value: S,
    defaultValue: T
  });
  return Kr("label", { css: [na(e), et(e)], ref: r, ...rt(d), children: [te("input", { type: "checkbox", css: ta(w || l, p), value: typeof n == "object" ? n.value : n, checked: w, disabled: a, onChange: (y) => {
    o === void 0 && b(y.target.checked), f == null || f(y.target.checked, y);
  } }), l ? te(zt, { css: Hr(!0) }) : te(Ut, { css: Hr(w) }), v && Kr("span", { css: ia, children: [" ", v] })] });
});
pr.displayName = "Checkbox";
const sa = vr((e, r) => {
  const { children: n, options: a, disabled: o, value: i, defaultValue: l, direction: f = "horizontal", spacing: p = f === "horizontal" ? "24px" : "16px", onChange: v, colorScheme: d, ...g } = e, [S, T] = Qr([], {
    value: i,
    defaultValue: l
  });
  let w;
  switch (f) {
    case "vertical":
      w = oa(p);
      break;
    case "horizontal":
      w = aa(p);
      break;
  }
  return te("div", { css: [w, et(e)], ref: r, ...rt(g), children: te(_r.Provider, { value: e, children: Wt(a) ? a == null ? void 0 : a.map((b, I) => {
    if (typeof b == "string" || typeof b == "number")
      return te(pr, { value: b, disabled: o, colorScheme: d, onChange: (m, y) => {
        let _ = [];
        m ? _ = [...S, b] : _ = S.filter((x) => x !== b), i === void 0 && T(_), v == null || v(_, y);
      }, children: b.toString() }, I);
    {
      const m = b;
      return te(pr, { value: m.value, disabled: o ?? m.disabled, colorScheme: d, onChange: (y, _) => {
        let x = [];
        y ? x = [...S, m.value] : x = S.filter((c) => c !== m.value), i === void 0 && T(x), v == null || v(x, _);
      }, children: m.label }, `${m.value}-${I}`);
    }
  }) : Yt.map(n, (b, I) => {
    const m = b;
    return Lt(m, {
      ...m.props,
      onChange: (y, _) => {
        var c, M;
        (M = (c = m.props).onChange) == null || M.call(c, y, _);
        let x = [];
        y ? m.props.value && (x = [...S, m.props.value]) : x = S.filter((O) => O !== m.props.value), i === void 0 && T(x), v == null || v(x, _);
      }
    });
  }) }) });
});
sa.displayName = "CheckboxGroup";
export {
  pr as Checkbox,
  sa as CheckboxGroup
};
//# sourceMappingURL=index.js.map
